import { Injectable } from '@angular/core';

import { SalePaths } from '@gipi-paths/sale.paths';
import { GIPIAbstractCrudService, GIPIBaseService } from '@gipisistemas/ng-core';
import { SaleReasonDevolutionFilterDTO } from '../models/reason-devolution-filter.dto';
import { SaleReasonDevolution } from '../models/reason-devolution.model';

@Injectable({ providedIn: 'root' })
export class SaleReasonDevolutionService extends GIPIAbstractCrudService<SaleReasonDevolution, SaleReasonDevolutionFilterDTO> {

    constructor(protected baseService: GIPIBaseService) {
        super(SalePaths.reasonDevolution, 'v1', baseService);
    }

}
